module.exports = __webpack_public_path__ + "static/media/donggubat_portfolio.d2332ef2.pdf";